<template>
  <!-- ページ内容 -->
  <div class="l-page l-page--team-add-user">
    <!-- メインコンテンツエリア -->
    <main class="l-main">
      <breadcrumb :breadcrumb-data="breadcrumbData" />

      <!-- メインコンテンツ: 上段共通エリア -->
      <div class="l-main-head">
        <h2 class="c-title u-w100p"><div class="c-title__text c-title__text--blue u-fs34">チームユーザーの編集</div></h2>
      </div>
      <!-- /メインコンテンツ: 上段共通エリア -->

      <!-- ユーザー情報入力エリア -->
      <div class="l-main-content">
        <add-user-form :team-url="teamUrl" :services="services" :initial-data="userData" />
      </div>
      <!-- /ユーザー情報入力エリア -->

    </main>
    <!-- /メインコンテンツエリア -->
  </div>
  <!-- /ページ内容 -->
</template>

<script>
export default {
  props: {
    breadcrumbData: Array,
    services: Array,
    teamUrl: String,
    userData: Object
  },
}
</script>
